/**
 * EngineeringPage.tsx - Strona modułów inżynierskich PlexiSystem
 * Wykorzystuje nowe moduły obliczeniowe
 */

import React from 'react';
import { EngineeringModules } from '../modules/engineering';

const EngineeringPage: React.FC = () => {
  return <EngineeringModules />;
};

export default EngineeringPage;
